export const DEFAULT_INPUT_TIMEOUT = 300;
export const FILTER_SELECTION_TIMEOUT = 1000;
export const DEFAULT_RESIZE_TIMEOUT = 300;
export const DEFAULT_NETWORK_TIMEOUT = 500;
export const LARGE_NETWORK_TIMEOUT = 1000;
